"use client"
import { Navbar, NavbarBrand, NavbarToggle, NavbarCollapse, NavbarLink, Button, Card, Footer, FooterCopyright, Accordion, AccordionContent, AccordionPanel, AccordionTitle } from 'flowbite-react';
import Link from "next/link";

import React from 'react';



export default function HomePage() {

  const [name, setName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [message, setMessage] = React.useState("");
  const [isError, setError] = React.useState(false);
  const [hasBeenSent, setHasBeenSent] = React.useState(false);
  const [responseMessage, setResponseMessage] = React.useState("")

  async function handleContactSubmit(event: React.ChangeEvent<HTMLFormElement>) {
    event.stopPropagation();
    event.preventDefault();

    console.log(name)
    console.log(email)

    console.log(message)

    setHasBeenSent(true);

    fetch('api/contact', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        'name': name,
        'email': email,
        'request': "AUCTIONBOOST SITE:" + message
      }),
    }).then(response => response.json())
      .then(data => {

        const res = data as ResponseData;
        console.log(res);

        setError(!res.success);
        setResponseMessage(res.message);

      }).catch((error) => {
        setError(true)
        setResponseMessage("Sorry, an error has occured.")
        console.error(error);
      })


    // Need to post this data somewhere...
  }

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 font-sans scroll-smooth">
      <header className="w-full sticky top-0 z-50 bg-gray-800 border-b border-gray-200">
        <Navbar fluid rounded className="max-w-7xl mx-auto bg-gray-800">
          <NavbarBrand href="#">
            <span className="self-center whitespace-nowrap text-xl font-black text-blue-600 tracking-tight">
              Auction<span className="text-emerald-500">Boost</span>
            </span>
          </NavbarBrand>
          <div className="flex md:order-2 gap-2">
            <Button href="/login" as={Link} color="gray" size="sm" className="font-semibold hover:bg-gray-800">
              Log In
            </Button>
            <Button color="blue" size="sm" href="#contact" >Book a Demo</Button>
            <NavbarToggle />
          </div>
          <NavbarCollapse className="text-gray-400">
            <NavbarLink className="text-gray-400" href="#benefits">Why AuctionBoost</NavbarLink>
            <NavbarLink className="text-gray-400" href="#pricing">Pricing</NavbarLink>
            <NavbarLink className="text-gray-400" href="#faq">FAQ</NavbarLink>
            <NavbarLink className="text-gray-400" href="#contact">Contact</NavbarLink>
          </NavbarCollapse>
        </Navbar>
      </header>

      <section className="relative bg-white py-20 px-4 overflow-hidden dark:bg-[#0B0F19]">
        <div className="max-w-5xl mx-auto text-center relative z-10">
          <span className="bg-blue-50 text-blue-700 text-xs font-semibold px-3 py-1 rounded-full uppercase tracking-wider dark:bg-gray-800 dark:text-indigo-400">
            Built Exclusively for Non-Profits
          </span>
          <h1 className="mt-6 text-4xl sm:text-6xl font-extrabold tracking-tight text-gray-900 leading-tight dark:text-white">
            Raise more funds. <br />
            <span className="text-blue-600">Minimize the checkout lines.</span>
          </h1>
          <p className="mt-6 text-lg sm:text-xl text-gray-500 max-w-2xl mx-auto leading-relaxed dark:text-gray-300">
            Stop letting long lines ruin your fundraising gala. AuctionBoost optimizes checkouts so your donors stay happy and go home early.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row justify-center gap-4">
            <Button href="#contact" color="blue" size="xl" className="font-semibold shadow-lg shadow-blue-500/20">
              Boost Your Next Gala
            </Button>
            <Button href="#benefits" color="light" size="xl" className="font-semibold">
              See How It Works
            </Button>
          </div>
        </div>
      </section>

      <section className="bg-gradient-to-r from-blue-700 to-indigo-800 py-12 px-4 text-white dark:bg-[#0B0F19]">
        <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
          {/*<div>
            <div className="text-3xl sm:text-4xl font-black text-emerald-400 font-mono tracking-tight">$42,850</div>
            <p className="text-xs sm:text-sm text-blue-100 mt-1 uppercase tracking-wider font-semibold">Funds Raised Tonight</p>
          </div>
          <div>
            <div className="text-3xl sm:text-4xl font-black text-emerald-400 font-mono tracking-tight">18.4 seconds</div>
            <p className="text-xs sm:text-sm text-blue-100 mt-1 uppercase tracking-wider font-semibold">Avg. Checkout Speed</p>
          </div>
          <div>
            <div className="text-3xl sm:text-4xl font-black font-mono tracking-tight">342</div>
            <p className="text-xs sm:text-sm text-blue-100 mt-1 uppercase tracking-wider font-semibold">Happy Donors Checked Out</p>
          </div>
          <div>
            <div className="text-3xl sm:text-4xl font-black font-mono tracking-tight">0 min</div>
            <p className="text-xs sm:text-sm text-blue-100 mt-1 uppercase tracking-wider font-semibold">Queue Wait Time</p>
          </div>*/}
        </div>
      </section>

      <section id="benefits" className="py-20 bg-slate-50 px-4 border-b border-gray-100 dark:bg-[#0B0F19]">
        <div className="max-w-7xl mx-auto">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <h2 className="text-3xl font-bold tracking-tight text-gray-900 dark:text-white">
              Happy donors give more generously
            </h2>
            <p className="mt-4 text-lg text-gray-500 dark:text-gray-300">
              Traditional charity auctions lose momentum at checkout. AuctionBoost fixes the bottleneck.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <Card className="border-0 shadow-sm bg-white">
              <div className="p-4">
                <div className="w-12 h-12 bg-blue-100 text-blue-600 rounded-lg flex items-center justify-center text-xl font-bold mb-4">⏱️</div>
                <h3 className="text-xl font-bold mb-2">Near Instant Checkout</h3>
                <p className="text-sm leading-relaxed">
                  Guests know what they won and owe quickly after the auction. Winning items are organized and ready for checkout when they are.
                </p>
              </div>
            </Card>

            <Card className="border-0 shadow-sm bg-white">
              <div className="p-4">
                <div className="w-12 h-12 bg-emerald-100 text-emerald-600 rounded-lg flex items-center justify-center text-xl font-bold mb-4">📊</div>
                <h3 className="text-xl font-bold mb-2">Live Bidding Metrics</h3>
                <p className="text-sm">
                  Track bids in real-time. Automatically nudge underperforming items to maximize total donations.
                </p>
              </div>
            </Card>

            <Card className="border-0 shadow-sm bg-white">
              <div className="p-4">
                <div className="w-12 h-12 bg-purple-100 text-purple-600 rounded-lg flex items-center justify-center text-xl font-bold mb-4">🚪</div>
                <h3 className="text-xl font-bold mb-2">Frictionless Exit</h3>
                <p className="text-sm leading-relaxed">
                  Digital tracking allow item pickup in seconds. Send your guests home smiling, not frustrated.
                </p>
              </div>
            </Card>
          </div>
        </div>
      </section>

      <section id="pricing" className="py-20 bg-white px-4 dark:bg-[#0B0F19]">
        <div className="max-w-7xl mx-auto">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <h2 className="text-3xl font-bold tracking-tight">
              Flexible support for any event size
            </h2>
            <p className="mt-4 text-lg">
              Choose the level of software and staffing support your team needs to succeed.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-start">
            <Card className="border shadow-none">
              <div className="mb-4">
                <h4 className="text-lg font-bold">Self-Service Software</h4>
                <p className="text-sm mt-1">For seasoned event committees.</p>
                <div className="mt-4 flex items-baseline text-gray-900 dark:text-gray-200">
                  <span className="text-5xl font-semibold">$</span>
                  <span className="text-5xl font-extrabold tracking-tight">499</span>
                  <span className="ml-1 text-sm font-semibold text-blue-600">+ 3% of sales</span>
                </div>
              </div>
              <ul className="space-y-3 my-6 text-sm text-gray-600 dark:text-gray-200">
                <li className="flex items-center">✅ Full auction software suite</li>
                <li className="flex items-center">✅ Email & text support</li>
                <li className="flex items-center text-gray-400">❌ Live event-night monitoring</li>
                <li className="flex items-center text-gray-400">❌ Bring your own devices</li>
              </ul>
              {/*<<Button color="light" className="w-full">Get Started</Button>*/}
            </Card>

            <Card className="border border-blue-600">
              <div className="mb-4">
                <h4 className="text-lg font-bold">On-Demand Support</h4>
                <p className="text-sm mt-1">For peace of mind on game day.</p>
                <div className="mt-4 flex items-baseline text-gray-900 dark:text-gray-200">
                  <span className="text-3xl font-semibold">$</span>
                  <span className="text-5xl font-extrabold tracking-tight">1,599</span>
                  <span className="ml-1 text-sm font-semibold text-blue-600">+ 3% of sales</span>
                </div>
              </div>
              <ul className="space-y-3 my-6 text-sm text-gray-600 dark:text-gray-200">
                <li className="flex items-center">✅ Everything in Self-Service</li>
                <li className="flex items-center font-semibold text-blue-600">✅ Dedicated remote technician</li>
                <li className="flex items-center">✅ 1-on-1 prep session for staff</li>
                <li className="flex items-center">✅ Real-time database monitoring</li>
              </ul>
              {/*<Button color="blue" className="w-full">Choose On-Demand</Button>*/}
            </Card>

            <Card className="border-2 border-gray-200 relative bg-slate-50 shadow-md">
              <div className="absolute top-0 right-6 transform -translate-y-1/2 bg-blue-600 text-white text-xs font-bold px-3 py-1 rounded-full uppercase">
                Most Popular
              </div>
              <div className="mb-4">
                <h4 className="text-lg font-bold">In-Person VIP</h4>
                <p className="text-sm mt-1">For high-stakes gala events.</p>
                <div className="mt-4 flex items-baseline text-gray-900 dark:text-gray-200">
                  <span className="text-3xl font-semibold">$</span>
                  <span className="text-5xl font-extrabold tracking-tight">7,999</span>
                  <span className="ml-1 text-sm font-semibold text-blue-600">+ 3% of sales</span>
                </div>
              </div>
              <ul className="space-y-3 my-6 text-sm text-gray-600 dark:text-gray-200">
                <li className="flex items-center">✅ Everything in On-Demand</li>
                <li className="flex items-center font-semibold text-blue-600">✅ 2 Tech experts onsite at your venue</li>
                <li className="flex items-center">✅ We run the check-in & checkout desks</li>
                <li className="flex items-center">✅ Hardware provided (frontdesk devices) </li>
              </ul>
              {/*<Button color="blue" className="w-full">Contact Sales</Button>*/}
            </Card>
          </div>
        </div>
      </section>

      <section id="faq" className="py-20 bg-white px-4 border-b border-gray-100 dark:bg-[#0B0F19]">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold tracking-tight">
              Frequently Asked Questions
            </h2>
            <p className="mt-4 text-lg">
              Everything you need to know about setting up your auction.
            </p>
          </div>

          <Accordion collapseAll className="border border-gray-200 rounded-xl overflow-hidden shadow-sm ">
            <AccordionPanel>
              <AccordionTitle className="text-base font-semibold text-gray-900 focus:ring-0">
                How does AuctionBoost speed up the event checkout line?
              </AccordionTitle>
              <AccordionContent>
                <p className="text-gray-500 dark:text-white text-sm leading-relaxed">
                  We efficiently organize and manage the item and bid number associations to optimize the checkout experience. When the auction closes, our system is able to efficiently and properly ingest the bids. This allows winners to know what they won, grab their items, and exit quickly.
                </p>
              </AccordionContent>
            </AccordionPanel>

            <AccordionPanel>
              <AccordionTitle className="text-base font-semibold text-gray-900 focus:ring-0">
                What does your human staffing support include?
              </AccordionTitle>
              <AccordionContent>
                <p className="text-gray-500 dark:text-white text-sm leading-relaxed">
                  We match your team with exactly the amount of help required. This ranges from basic system readiness checkups, to dedicated remote technical monitors active throughout game-night, up to fully managed on-site teams who bring physical hardware devices and run your entire registration and checkout stations for you.
                </p>
              </AccordionContent>
            </AccordionPanel>

            <AccordionPanel>
              <AccordionTitle className="text-base font-semibold text-gray-900 focus:ring-0">
                Do you provide physical hardware for the events?
              </AccordionTitle>
              <AccordionContent>
                <p className="text-gray-500 dark:text-white text-sm leading-relaxed">
                  Yes, for events requesting high-touch packages, physical check-in tablets, barcode scanners, and processing equipment are delivered directly to your venue. Alternatively, our clean cloud software runs flawlessly on any mobile phone or browser tablet your existing volunteers already own.
                </p>
              </AccordionContent>
            </AccordionPanel>

            <AccordionPanel>
              <AccordionTitle className="text-base font-semibold text-gray-900 focus:ring-0">
                Are there transaction fees on the donations raised?
              </AccordionTitle>
              <AccordionContent>
                <p className="text-gray-500 dark:text-white text-sm leading-relaxed">
                  We provide event packages that work best to support non-profits without penalizing them for not selling items or having a smaller than expected turnout. We recommend using your own point of sale machines to ensure donors see your non-profit name in their card statements.
                </p>
              </AccordionContent>
            </AccordionPanel>
          </Accordion>
        </div>
      </section>

      <section id="contact" className="py-20 bg-white px-4 dark:bg-[#0B0F19]">
        <div className="max-w-2xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold tracking-tight ">
              Let's secure your event date
            </h2>
            <p className="mt-3 text-base text-gray-500 dark:text-gray-200">
              Have an upcoming gala? Drop us a line and let our experts help find the right package for your non-profit.
            </p>
          </div>

          {!hasBeenSent && <form onSubmit={handleContactSubmit} className="space-y-6 bg-slate-50 p-8 rounded-2xl border border-gray-100 shadow-sm">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div>
                <label className="block mb-2 text-sm font-semibold text-gray-700">Your Name</label>
                <input type="text" placeholder="Jane Doe" required onChange={(event) => setName(event?.target.value)} className="w-full px-4 py-2.5 rounded-lg border border-gray-300 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500" />
              </div>
              <div>
                <label className="block mb-2 text-sm font-semibold text-gray-700">Organization Email</label>
                <input type="email" onChange={(event) => setEmail(event?.target.value)} placeholder="jane@charity.org" required className="w-full px-4 py-2.5 rounded-lg border border-gray-300 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500" />
              </div>
            </div>

            {/*
            <div>
              <label className="block mb-2 text-sm font-semibold text-gray-700">Event Date (Approximate)</label>
              <input type="date" required className="w-full px-4 py-2.5 rounded-lg border border-gray-300 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500" />
            </div>*/}

            <div>
              <label className="block mb-2 text-sm font-semibold text-gray-700">How can we help you boost your auction?</label>
              <textarea rows={4} placeholder="Tell us about your expected guests, estimated auction items, or special requirements..." className="w-full px-4 py-2.5 rounded-lg border border-gray-300 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500" defaultValue={""} onChange={(event) => setMessage(event?.target.value)} />
            </div>

            <Button type="submit" color="blue" className="w-full font-bold">
              Send Message
            </Button>
          </form>}
          {hasBeenSent && <p>Message Sent. We will reach out to you shortly!</p>}
        </div>
      </section>

      <Footer container className="bg-slate-900 text-white rounded-none">
        <div className="w-full max-w-7xl mx-auto py-6 flex flex-col sm:flex-row justify-between items-center gap-4">
          <span className="text-lg font-bold text-blue-400">
            Auction<span className="text-emerald-400">Boost</span>
          </span>
          <FooterCopyright href="#" by="Nibious LLC. All rights reserved." year={2026} className="text-gray-400" />
        </div>
      </Footer>
    </div>
  );
}
